import CryptoJS from "crypto-js";

const SECRET_KEY =
    process.env.REACT_APP_STORAGE_SECRET || "SYMCARE_SUPER_SECRET";

export const setSecureSessionItem = (key, value) => {
    const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(value),
        SECRET_KEY
    ).toString();

    sessionStorage.setItem(key, encrypted);
};

export const getSecureSessionItem = (key) => {
    const encrypted = sessionStorage.getItem(key);
    if (!encrypted) return null;

    try {
        const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch {
        return null; // tampered or invalid
    }
};

export const removeSecureSessionItem = (key) => {
    sessionStorage.removeItem(key);
};
